import React from 'react';
import { Box } from '@mui/material';
import { getMilitaryRankStage } from '../utils/militaryRankUtils';

const LevelIcon = ({ level, size = 40, showSubLevel = true }) => {
  const rankInfo = getMilitaryRankStage(level);
  
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        width: size,
        height: size
      }}
    >
      {/* 主图标 */}
      <Box
        sx={{
          fontSize: size * 0.7,
          lineHeight: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        {rankInfo.stageIcon}
      </Box>
      
      {/* 子等级数字 */}
      {showSubLevel && (
        <Box
          sx={{
            position: 'absolute',
            bottom: -2,
            right: -2,
            backgroundColor: rankInfo.color,
            color: '#fff',
            borderRadius: '50%',
            width: size * 0.35,
            height: size * 0.35,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: size * 0.25,
            fontWeight: 'bold',
            border: '1px solid #fff'
          }}
        >
          {rankInfo.subLevel}
        </Box>
      )}
    </Box>
  );
};

export default LevelIcon;